import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const isActive = (pathname, itemPath) => {
  if (itemPath === '/') return pathname === '/';
  return pathname.startsWith(itemPath);
};

export const DesktopMenu = ({ primaryNav, secondaryNav, location, moreOpen, setMoreOpen, moreRef, secondaryIsActive }) => (
  <div className="hidden lg:flex items-center gap-8">
    {primaryNav.map((link) => {
      const active = isActive(location.pathname, link.path);
      return active ? (
        <span
          key={link.path}
          className="text-sm font-semibold text-primary border-b-2 border-primary pb-0.5 cursor-default"
          data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
        >
          {link.name}
        </span>
      ) : (
        <Link
          key={link.path}
          to={link.path}
          className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
          data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
        >
          {link.name}
        </Link>
      );
    })}

    {/* More dropdown */}
    <div className="relative" ref={moreRef}>
      <button
        onClick={() => setMoreOpen(!moreOpen)}
        className={`text-sm font-medium flex items-center gap-1 transition-colors ${
          secondaryIsActive ? 'text-primary' : 'text-muted-foreground hover:text-primary'
        }`}
        data-testid="nav-more"
      >
        More <ChevronDown className={`w-3.5 h-3.5 transition-transform ${moreOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {moreOpen && (
          <motion.div
            className="absolute right-0 top-full mt-3 w-48 bg-card border border-border/30 rounded-xl shadow-xl overflow-hidden"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.15 }}
            data-testid="nav-more-dropdown"
          >
            {secondaryNav.map((link) => {
              const active = isActive(location.pathname, link.path);
              return active ? (
                <span
                  key={link.path}
                  className="block px-4 py-2.5 text-sm font-semibold text-primary bg-primary/10 cursor-default"
                  data-testid={`nav-more-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </span>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block px-4 py-2.5 text-sm text-slate-300 hover:text-primary hover:bg-slate-800/50 transition-colors"
                  data-testid={`nav-more-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>

    {/* Contact CTA */}
    {isActive(location.pathname, '/contact') ? (
      <span
        className="text-sm font-semibold text-primary border border-primary/40 rounded-full px-5 py-1.5 cursor-default"
        data-testid="nav-contact"
      >
        Contact
      </span>
    ) : (
      <Link
        to="/contact"
        className="text-sm font-semibold text-white border border-primary/60 rounded-full px-5 py-1.5 hover:bg-primary hover:text-white transition-all"
        data-testid="nav-contact"
      >
        Contact
      </Link>
    )}
  </div>
);
